import React from "react";

const LeaveDateRange = ({ startDate, endDate, onChange }) => {
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="form-row">
      <div className="form-group">
        <label>From:</label>
        <input
          type="date"
          value={startDate}
          min={today}
          onChange={(e) => onChange("startDate", e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>To:</label>
        <input
          type="date"
          value={endDate}
          min={startDate || today}
          onChange={(e) => onChange("endDate", e.target.value)}
        />
      </div>
    </div>
  );
};

export default LeaveDateRange;
